import React from 'react'
import Link from 'gatsby-link'
import { stack as Menu } from 'react-burger-menu'
var menuicon = require('../../content/menu.svg')

import './index.css'

class MenuMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen })
  }

  closeMenu() {
    this.setState({ menuOpen: false })
    console.log(this)
  }

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render() {
    return (
      <Menu right width={'100px'} customBurgerIcon={<img src={menuicon} />}>
        <Link
          className="menu-item"
          to={{ pathname: '/editorial/', state: { isOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Editorial
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/portrait/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Portrait
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/travel/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Travel
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/freiearbeit/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          freie Arbeit
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/reportage/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Reportage
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/wedding/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Wedding
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/about/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          About
        </Link>
        <Link
          className="menu-item"
          to={{ pathname: '/contact/', state: { menuOpen: false } }}
          activeClassName={'mobile-menu-active'}
          style={{ marginBottom: '0.5em', width: 'auto', display: 'inline-block' }}>
          Contact
        </Link>
      </Menu>
    )
  }
}

export default MenuMobile



// WEBPACK FOOTER //
// ./src/components/MenuMobile/index.js